import { USA_STATES_LIST } from '@Types/consts';
import type { Country } from '@Types/country';

export const getStateDropdownItem = (
  state?: string,
  country?: Country | null,
  validStates?: { title: string; value: string }[]
) => {
  if (country) {
    const stateobj = country.subDivisions?.find((stateItem) => stateItem.code === state);
    return {
      title: stateobj?.name || '',
      value: stateobj?.code || '',
    };
  }
  if (!state) return null;
  const list = validStates ?? USA_STATES_LIST;
  const stateData = list.find((item) => item.value === state);
  if (!stateData) return null;
  return {
    title: stateData.title,
    value: stateData.value,
  };
};

export const getInitialState = (state: string) => {
  const stateData = USA_STATES_LIST.find((item) => item.value === state);
  return {
    title: stateData?.title || '',
    value: stateData?.value || '',
  };
};
